import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/** Scrolls to the top on every new page (link click), but keeps the position on back/forward. */
export function ScrollToTop(): null {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== 'POP') window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}
